import React, { Fragment } from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import TableCollapsible from './TableCollapsible';

const Table = ({
  data,
  columns,
  handleClick,
  selectedId,
  clickTarget,
  className,
  bodyClassName,
  overrideClass,
  cellProps,
  headerProps,
  collapsible,
  collapsibleProps
}) => {
  const renderData = (column, idx, data, props) => (
    <td key={column.id} className='prl3-sm pt5-sm pb5-sm' data-desc={`table__row${idx}_${column.id}`}>
      {column && column.cell ? column.cell(data, props) : data[column.id]}
    </td>
  );
  return (
    <div className={classnames(overrideClass || 'table__wrapper', className)} data-testid='_test_table'>
      <table>
        <thead className='table__header ta-sm-l body-4'>
          <tr className='table__header-row'>
            {columns &&
              columns.map(column => (
                <th key={column.id} className='table__header-th p3-sm'>
                  {typeof column.header === 'function' ? column.header(data, headerProps) : column.header}
                </th>
              ))}
            {collapsible && <th />}
          </tr>
        </thead>
        <tbody className={classnames('table__body body-3', bodyClassName)}>
          {data &&
            data.map((d, idx) => {
              const Collapsible = collapsible;
              return (
                // eslint-disable-next-line
                <Fragment key={`table__tr-${d[clickTarget] || ''}-${idx}`}>
                  {collapsible ? (
                    <TableCollapsible
                      trigger={columns.map(column => renderData(column, idx, d, cellProps))}
                      classParentString='table_collapsible'
                      colSpan={columns.length + 1}
                      collapsibleProps={collapsibleProps}
                    >
                      <Collapsible collapsibleProps={collapsibleProps}>{d}</Collapsible>
                    </TableCollapsible>
                  ) : (
                    <tr
                      className={classnames('table__body-row body-3', {
                        highlighted: selectedId && selectedId === d[clickTarget]
                      })}
                      onClick={handleClick ? e => handleClick(d[clickTarget], e) : null}
                      data-id={d.id || ''}
                    >
                      {columns.map(column => renderData(column, idx, d, cellProps))}
                    </tr>
                  )}
                </Fragment>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

Table.defaultProps = {
  bodyClassName: null,
  cellProps: null,
  className: null,
  clickTarget: 'id',
  collapsible: null,
  collapsibleProps: null,
  handleClick: null,
  overrideClass: null,
  selectedId: null,
  headerProps: null
};

Table.propTypes = {
  bodyClassName: PropTypes.string,
  cellProps: PropTypes.any,
  collapsibleProps: PropTypes.any,
  className: PropTypes.string,
  clickTarget: PropTypes.string,
  collapsible: PropTypes.any,
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  handleClick: PropTypes.func,
  overrideClass: PropTypes.string,
  selectedId: PropTypes.string,
  headerProps: PropTypes.object
};

export default Table;
